export enum Network {
  Ethereum = 'ethereum',
  Arbitrum = 'arbitrum',
}
